import { render, staticRenderFns } from "./CadastrarPainelUnidade.vue?vue&type=template&id=572df712"
import script from "./CadastrarPainelUnidade.vue?vue&type=script&lang=js"
export * from "./CadastrarPainelUnidade.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports